import React from "react";
import { Helmet } from "react-helmet";

const faviconMap = {
  nectar: `${process.env.PUBLIC_URL}/nectar`,
  default: `${process.env.PUBLIC_URL}/favicon`,
};

const getFaviconPath = (logo) => {
  return faviconMap[logo] || faviconMap["default"];
};

const DocumentHead = ({ logo, mission }) => {
  return (
    <Helmet defer={false}>
      <link rel="apple-touch-icon" href={`${getFaviconPath(logo)}.png`} />
      <link rel="shortcut icon" href={`${getFaviconPath(logo)}.ico`} />
      {mission && <title>{mission} Log in</title>}
    </Helmet>
  );
};

export default DocumentHead;
